export interface LNavigationRoute {
  name: string
  displayName: string
  meta: { icon: string }
  children?: LNavigationRoute[]
}

import { recruitmentTrainingNavigationRoute } from './recruitmentTrainingNavigation'

const filterRoutesByRole = (routes: LNavigationRoute[], role: string): LNavigationRoute[] => {
  return routes
    .filter((route) => {
      // Check if the route has allowed roles, and if the user's role is allowed
      if (route.meta.allowedRoles && route.meta.allowedRoles.includes(role)) {
        return true // Accessible by the user's role
      }
      // Fallback condition for routes without role restrictions (e.g., dashboard)
      if (!route.meta.allowedRoles) {
        return true // Accessible by everyone
      }
      return false // Hide route if not allowed for the user's role
    })
    .map((route) => {
      // Recursively filter children routes if any
      if (route.children) {
        route.children = filterRoutesByRole(route.children, role)
      }
      return route
    })
}

const sidebarRoutes = {
  root: {
    name: '/',
    displayName: 'navigationRoutes.home',
  },
  routes: [
    {
      name: 'dashboard-v2',
      displayName: 'Dashboard',
      meta: {
        icon: 'vuestic-iconset-dashboard',
        allowedRoles: ['admin', 'operator'],
      },
    },

    // {
    //   name: 'operators',
    //   displayName: 'Operators',
    //   meta: { icon: 'support_agent', allowedRoles: ['admin'] },
    // },
    {
      name: 'our-drivers',
      displayName: 'Drivers',
      meta: { icon: 'moped', allowedRoles: ['admin', 'operator'] },
      children: [
        {
          name: 'our-drivers',
          displayName: 'All Drivers',
          meta: { icon: 'moped', allowedRoles: ['admin', 'operator'] },
        },
        {
          name: 'driver-matching',
          displayName: 'Driver Matching',
          meta: { icon: 'link', allowedRoles: ['admin', 'operator'] },
        },
      ],
    },
    recruitmentTrainingNavigationRoute,
    {
      name: 'our-vehicles',
      displayName: 'Assets',
      meta: { icon: 'directions_car', allowedRoles: ['admin', 'operator'] },
      children: [
        {
          name: 'our-vehicles',
          displayName: 'Mobile Assets',
          meta: { icon: 'directions_car', allowedRoles: ['admin', 'operator'] },
        },
        {
          name: 'tracking-devices',
          displayName: 'Tracking Devices',
          meta: { icon: 'gps_fixed', allowedRoles: ['admin', 'operator'] },
        },
        {
          name: 'vehicle-mapping',
          displayName: 'Vehicle Mapping',
          meta: { icon: 'link', allowedRoles: ['admin', 'operator'] },
        },
      ],
    },
    {
      name: 'issues',
      displayName: 'Tickets',
      meta: { icon: 'dataset', allowedRoles: ['admin', 'operator'] },
    },
    // {
    //   name: 'payments',
    //   displayName: 'Maintenance',
    //   meta: { icon: 'engineering', allowedRoles: ['admin'] },
    //   children: [
    //     { name: 'maintenance', displayName: 'List', meta: { icon: 'list-icon', allowedRoles: ['admin'] } },
    //      { name: 'maintenance-items', displayName: 'Items', meta: { icon: 'list-icon', allowedRoles: ['admin'] } },
    //         { name: 'maintenance-workshops', displayName: 'Workshops', meta: { icon: 'list-icon', allowedRoles: ['admin'] } }
    //   ],
    // },
    {
      name: 'messages',
      displayName: 'Messages',
      meta: { icon: 'message', allowedRoles: ['admin', 'operator'] },
    },
    {
      name: 'reports',
      displayName: 'Reports',
      meta: { icon: 'today', allowedRoles: ['admin', 'operator'] },
      children: [
        {
          name: 'reports',
          displayName: 'All Reports',
          meta: {
            icon: 'assessment',
            allowedRoles: ['admin', 'operator'],
          },
        },
        {
          name: 'trips',
          displayName: 'Trips',
          meta: { icon: 'folder_shared', allowedRoles: ['admin', 'operator'] },
        },
        {
          name: 'uteh-vehicles',
          displayName: 'UTEH Vehicles',
          meta: { icon: 'directions_car', allowedRoles: ['admin', 'operator'] },
        },
        {
          name: 'odometer-reports',
          displayName: 'Odometer Reports',
          meta: {
            icon: 'speed',
            allowedRoles: ['admin', 'operator'],
          },
        },
        {
          name: 'charging-reports',
          displayName: 'Charging Reports',
          meta: {
            icon: 'battery_charging_full',
            allowedRoles: ['admin', 'operator'],
          },
        },
        {
          name: 'vehicle-activity-reports',
          displayName: 'Vehicle Activity',
          meta: {
            icon: 'sensors',
            allowedRoles: ['admin', 'operator'],
          },
        },
        {
          name: 'fleet-telemetry-reports',
          displayName: 'Fleet Telemetry',
          meta: {
            icon: 'sensors',
            allowedRoles: ['admin', 'operator'],
          },
        },
      ],
    },
    {
      name: 'analytics',
      displayName: 'Analytics',
      meta: { icon: 'analytics', allowedRoles: ['admin', 'operator'] },
    },
    {
      name: 'tickets',
      displayName: 'Tickets',
      meta: { icon: 'assignment', allowedRoles: ['admin', 'operator'] },
    },
    {
      name: 'violations-escalation',
      displayName: 'Violations Escalation',
      meta: { icon: 'gpp_maybe', allowedRoles: ['admin', 'operator'] },
    },
    {
      name: 'maintenance',
      displayName: 'Maintenance',
      meta: { icon: 'engineering', allowedRoles: ['admin', 'operator'] },
      children: [
        {
          name: 'maintenance',
          displayName: 'Maintenance List',
          meta: { icon: 'list', allowedRoles: ['admin', 'operator'] },
        },
        {
          name: 'maintenance-items',
          displayName: 'Maintenance Items',
          meta: { icon: 'inventory', allowedRoles: ['admin', 'operator'] },
        },
        {
          name: 'maintenance-workshops',
          displayName: 'Workshops',
          meta: { icon: 'business', allowedRoles: ['admin', 'operator'] },
        },
      ],
    },
    {
      name: 'ev-dashboard',
      displayName: 'EV Dashboard',
      meta: { icon: 'electric_car', allowedRoles: ['admin', 'operator'] },
    },
    {
      name: 'compare',
      displayName: 'Compare',
      meta: { icon: 'compare_arrows', allowedRoles: ['admin', 'operator'] },
    },
    {
      name: 'issues',
      displayName: 'Issues',
      meta: { icon: 'warning', allowedRoles: ['admin', 'operator'] },
    },
    {
      name: 'preferences',
      displayName: 'Profile',
      meta: { icon: 'manage_accounts', allowedRoles: ['admin', 'operator'] },
    },
    // {
    //   name: 'settings',
    //   displayName: 'Settings',
    //   meta: { icon: 'settings', allowedRoles: ['admin', 'operator'] },
    // },
  ],
}

export default sidebarRoutes
